export default "__VITE_ASSET__a92a9bea__"